import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'
import type { FieldglassOperationIssueType } from 'pages/Fieldglass/shared/constants/issueTypes'

export type FieldglassJobPostingIssue = {
  id: number
  issueType: FieldglassOperationIssueType
  issueTypeLabel: string
  message: string
  workerId: number | null
  workerName: string | null
  shiftId: number | null
}

export type FieldglassJobPostingWorker = {
  workerId: number
  workerName: string | null
  status: string
  issues: FieldglassJobPostingIssue[]
}

export type FieldglassJobPostingShift = {
  shiftId: number
  positionName: string | null
  locationName: string | null
  startsAt: string
  endsAt: string
  cancelled: boolean
  workers: FieldglassJobPostingWorker[]
}

export type GetFieldglassJobPostingRequest = {
  jobPostingId: string
}

export type GetFieldglassJobPostingResponse = {
  jobPostingId: string
  companyGroupId: number
  companyGroupName: string | null
  shifts: FieldglassJobPostingShift[]
  issues: FieldglassJobPostingIssue[]
}

export const getFieldglassJobPosting = async (
  request: GetFieldglassJobPostingRequest
): Promise<GetFieldglassJobPostingResponse> => {
  const params = {
    job_posting_id: request.jobPostingId,
  }

  const response = await api.get<GetFieldglassJobPostingResponse>(
    '/admin/fieldglass/job_posting',
    { params, paramsSerializer: queryParamSerializer }
  )
  return response.data
}
